import { render, staticRenderFns } from "./ValidateDialog.vue?vue&type=template&id=8176a6e2"
import script from "./ValidateDialog.vue?vue&type=script&lang=js"
export * from "./ValidateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports